import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import { siteConfig } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isTransparent = isHome && !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-xl font-semibold whitespace-nowrap transition-colors ${
              isTransparent ? 'text-white' : 'text-foreground-900'
            }`}
          >
            {siteConfig.name}
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isTransparent
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isTransparent
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              isTransparent ? 'text-white' : 'text-foreground-700'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}